import { render, staticRenderFns } from "./PresetButtons.vue?vue&type=template&id=c955f0e2"
import script from "./PresetButtons.vue?vue&type=script&lang=js"
export * from "./PresetButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports